module.exports = __webpack_public_path__ + "media/icons/check-1fd0fef6.svg";